var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedinLogin = function SvgLinkedinLogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D65C3",
    fillRule: "evenodd",
    d: "M16 29.333c7.364 0 13.333-5.97 13.333-13.333 0-7.364-5.97-13.334-13.333-13.334C8.636 2.666 2.666 8.636 2.666 16S8.636 29.333 16 29.333zm-5.746-18.158a1.72 1.72 0 1 0 0-3.438 1.72 1.72 0 0 0 0 3.437zm-1.72 1.475h3.518v10.816H8.533V12.65zm13.064.115.037.012a3.508 3.508 0 0 1 2.631 3.39v7.3H20.75v-6.884c-1.122-2.72-3.78.984-3.78.984v5.9h-3.52V12.65h3.52v2.068c.428-.576 1.729-2.068 3.78-2.068.24 0 .445.026.632.064.048.008.095.016.142.027l.075.024z",
    clipRule: "evenodd"
  })));
};
export default SvgLinkedinLogin;